import { useTranslation } from "react-i18next";
import { SelectionCircle } from "./SelectionCircle";

type UnavailableToggleProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
};

// Per-variant "unavailable" tick box shared by the create and edit forms.
export function UnavailableToggle({ checked, onChange }: UnavailableToggleProps) {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={checked}
      onClick={() => onChange(!checked)}
      className="group flex w-fit cursor-pointer items-center gap-2 text-sm font-medium text-foreground"
    >
      <SelectionCircle checked={checked} />
      <span>{t("variant.unavailable")}</span>
    </button>
  );
}
